module.exports = __webpack_public_path__ + "static/media/CancelCircle.a5211bf2.svg";